

import { ChangeEvent, FC, forwardRef, useState } from 'react';

import { InputText } from '@eneco/sparky';
import { InputTextProps } from '@eneco/sparky/types';

interface Props {
  onChange: (value: string) => void;
}

const CustomerIdInput: FC<InputTextProps & Props> = forwardRef((props, ref) => {
  const [viewValue, setViewValue] = useState('');

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const matches = e.target.value.replace(/[^\d-]/g, '').match(/([1-9]\d{0,9}|[1-9]{0,10})(-\d*)?/);
    if (!matches) return;

    const customerId = matches[1];
    const accountId = matches[2];

    const masked = `${customerId}${customerId && accountId ? accountId : ''}`;

    setViewValue(masked);
    props.onChange(customerId);
  };

  return <InputText {...props} ref={ref} onChange={onChangeHandler} value={viewValue || props.value || ''} />;
});

export default CustomerIdInput;
